import { generateReducer } from "../../common/helpers";
import {
    INVOICE_RECOMMENDATION_DATA,
    INVOICE_RECOMMENDATION_ERROR,
    INVOICE_RECOMMENDATION_LOADING,
    INVOICE_RECOMMENDATION_TOGGLE,
} from "../constants";

const initialState = {
    productsForDay: [],
    errorProductsForDay: null,
    isLoadingProductsForDay: false,
    showModal: false,
};

const toggle = state => ({ ...state, showModal: !state.showModal });
const setLoading = (state, isLoadingProductsForDay) => ({ ...state, isLoadingProductsForDay });
const setData = (state, data) => ({
    ...state,
    productsForDay: data,
    isLoadingProductsForDay: false,
});
const setError = (state, error) => ({
    ...state,
    isLoadingProductsForDay: false,
    errorProductsForDay: error,
});

export const reducers = {
    [INVOICE_RECOMMENDATION_DATA]: setData,
    [INVOICE_RECOMMENDATION_LOADING]: setLoading,
    [INVOICE_RECOMMENDATION_TOGGLE]: toggle,
    [INVOICE_RECOMMENDATION_ERROR]: setError,
};

export default generateReducer(reducers, initialState);
